import React from 'react';
export const CFIconChevronUp = {
    alias: 'chevron-up',
    defaultTitle: 'Chevron Up',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M18 15a.996.996 0 0 1-.64-.232l-5.371-4.476-5.362 4.315a.999.999 0 1 1-1.253-1.558l6-4.828a.998.998 0 0 1 1.267.011l6 5A1 1 0 0 1 18 15Z' }))),
};
